module.exports = __webpack_public_path__ + "static/aesthetic-awards-63b9c4032e0a3dd11ac5b487e5ccc070.png";